import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Tracker} from 'shared';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-fuel-realtime-consumption-popup',
  templateUrl: './fuel-realtime-consumption-popup.component.html',
  styleUrls: ['./fuel-realtime-consumption-popup.component.scss']
})
export class FuelRealtimeConsumptionPopupComponent implements OnInit {

  @Input()
  name: string;

  @Input()
  tracker: Tracker;

  @Input()
  visible = true;

  @Output()
  visibleChange = new EventEmitter<boolean>();

  @Input()
  width?: number;

  @Input()
  height?: number;

  start: boolean;

  constructor() {
  }

  ngOnInit() {
  }

  onHidden(e: any) {
    this.visibleChange.emit(false);
    this.start = false;
  }

  onShowing(e: any) {
    this.start = true;
  }
}
